import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { VERTICALS, MEDIA_GROUP_URL, LOGO_DARK, PHONE_DISPLAY, PHONE_TEL } from "@/lib/brand";

export default function Footer() {
  return (
    <footer className="bg-ink text-white" data-testid="global-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <img src={LOGO_DARK} alt="On The Brink — Visionary Growth Partners" className="h-16 w-auto object-contain" />
            <p className="mt-5 text-sm text-slate-400 max-w-xs leading-relaxed">
              Visionary Growth Partners. Hardware + Brainpower — physical AV infrastructure paired with autonomous Agentic AI marketing.
            </p>
            <a href={PHONE_TEL} data-testid="footer-phone"
               className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-ember transition-colors">
              <Phone className="h-4 w-4 text-ember" /> {PHONE_DISPLAY}
            </a>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">Company</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/about" data-testid="footer-about" className="text-slate-300 hover:text-ember transition-colors">About Us</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="text-slate-300 hover:text-ember transition-colors">Contact</Link></li>
              <li><Link to="/login" data-testid="footer-portal" className="text-slate-300 hover:text-ember transition-colors">Client Portal (Login)</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy" className="text-slate-300 hover:text-ember transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-5">
            <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">The Ecosystem</h4>
            <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              {VERTICALS.map((v) => (
                <li key={v.id}>
                  <a href={v.url} target={v.url !== "#" ? "_blank" : undefined} rel="noreferrer"
                     data-testid={`footer-vertical-${v.id}`}
                     className="text-slate-300 hover:text-ember transition-colors">{v.name}</a>
                </li>
              ))}
              <li>
                <a href={MEDIA_GROUP_URL} target={MEDIA_GROUP_URL !== "#" ? "_blank" : undefined} rel="noreferrer"
                   data-testid="footer-media-group" className="text-slate-300 hover:text-ember transition-colors">
                  OTB Media Group
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-400">On The Brink™ – An AI-First Service Agency.</p>
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} On The Brink. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
